(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_got-questions-button"] && !Shopify.designMode) return;
  try {
    const initGotQuestionsButton = (button) => {
    if (!button) return;
    

    const section = button.closest('section');
    const list = section ?. querySelector('.got-questions__list');
    if (! list) return;
    

    if (list.dataset.hasHidden === 'false') {
      button.setAttribute('hidden', '');
      return;
    }
    if (list.id) {
      button.setAttribute('aria-controls', list.id);
    }

    const updateButtonText = () => {
      const expandedText = button.dataset.expandedText;
      if (! expandedText) return;
      
      const textNode = button.querySelector('.got-questions__button-text');
      if (textNode) 
        textNode.textContent = expandedText;
      
    };

    button.addEventListener('click', () => {
      if (list.classList.contains('got-questions__list--expanded')) return;
      

      list.classList.add('got-questions__list--expanded');
      list.querySelectorAll('.got-questions__item--hidden').forEach((item) => {
        item.classList.remove('got-questions__item--hidden');
        item.removeAttribute('hidden');
      });
      button.setAttribute('aria-expanded', 'true');
      updateButtonText();

// Update hasHidden flag since all items are now visible
      list.dataset.hasHidden = 'false';

// Hide the button after displaying all questions
      button.setAttribute('hidden', '');
    });
  };

  document.querySelectorAll('.got-questions__button').forEach(initGotQuestionsButton);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_got-questions-list"] && !Shopify.designMode) return;
  try {
    const initGotQuestionsList = (list) => {
    if (!list) return;
    if (list.classList.contains('got-questions__list--expanded')) return;

    const visibleCount = parseInt(list.dataset.visibleCount || '0', 10);
    if (!visibleCount || Number.isNaN(visibleCount)) return;

    const items = list.querySelectorAll('.got-questions__item');
    let hasHidden = false;

    items.forEach((item, index) => {
      if (index + 1 > visibleCount) {
        item.classList.add('got-questions__item--hidden');
        item.setAttribute('hidden', '');
        hasHidden = true;
      } else {
        item.classList.remove('got-questions__item--hidden');
        item.removeAttribute('hidden');
      }
    });

    list.dataset.hasHidden = hasHidden ? 'true' : 'false';
  };

  const lists = document.querySelectorAll('.got-questions__list[data-visible-count]');
  lists.forEach(initGotQuestionsList);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_how-work-verified-buyer-card"] && !Shopify.designMode) return;
  try {
    (function() {
    const cards = document.querySelectorAll('[data-video-card]');

    cards.forEach(function(card) {
      const video = card.querySelector('video');
      const button = card.querySelector('[data-video-control]');
      const playIcon = card.querySelector('.card__controls-icon--play');
      const pauseIcon = card.querySelector('.card__controls-icon--pause');

      if (! video || ! button) return;
      


      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (video.paused) {
          video.play();
          if (playIcon) 
            playIcon.style.display = 'none';
          


          if (pauseIcon) 
            pauseIcon.style.display = 'block';
          


        } else {
          video.pause();
          if (playIcon) 
            playIcon.style.display = 'block';
          


          if (pauseIcon) 
            pauseIcon.style.display = 'none';
          


        }
      });

      video.addEventListener('pause', function() {
        if (playIcon) 
          playIcon.style.display = 'block';
        


        if (pauseIcon) 
          pauseIcon.style.display = 'none';
        


      });

      video.addEventListener('play', function() {
        if (playIcon) 
          playIcon.style.display = 'none';
        


        if (pauseIcon) 
          pauseIcon.style.display = 'block';
        


      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_modal-addon-product"] && !Shopify.designMode) return;
  try {
    class ModalAddonProduct extends HTMLElement {
    connectedCallback() {
      const checkbox = this.querySelector('.modal-addon-product__switch-input');
      if (checkbox) {
        checkbox.addEventListener('change', (e) => {
          this.handleToggle(e.target.checked);
        });
      }
    }

    handleToggle(checked) {
      const productId = this.querySelector('.modal-addon-product__option')?.dataset.productId;
      if (productId) {
        this.dispatchEvent(new CustomEvent('addon-toggle', {
          detail: { productId, enabled: checked },
          bubbles: true
        }));
      }
    }
  }

  customElements.define('modal-addon-product', ModalAddonProduct);

  // Handle gelflex badge update for specific product ID
  function updateGelflexBadge(checkbox) {
    const gelflexBadge = document.querySelector('[data-ref="gelflexBadge"]');
    if (!gelflexBadge || !checkbox) return;
    
    const selectedProduct = gelflexBadge.closest('modal-selected-product');
    const withGelflexText = selectedProduct?.dataset.withGelflexText || 'With Gelflex';
    const noGelflexText = selectedProduct?.dataset.noGelflexText || 'No Gelflex';
    
    if (checkbox.checked) {
      gelflexBadge.textContent = withGelflexText;
      gelflexBadge.classList.remove('modal-selected-product__variant-badge--secondary');
    } else {
      gelflexBadge.textContent = noGelflexText;
      gelflexBadge.classList.add('modal-selected-product__variant-badge--secondary');
    }
  }

  // Listen for checkbox changes on the specific product ID using event delegation
  document.addEventListener('change', (e) => {
    if (e.target.classList.contains('modal-addon-product__switch-input')) {
      const addonOption = e.target.closest('.modal-addon-product__option');
      if (addonOption && addonOption.dataset.productId === '10516921352530') {
        updateGelflexBadge(e.target);
      }
    }
  });

  // Set initial state when DOM is ready
  function checkInitialState() {
    const addonOption = document.querySelector('.modal-addon-product__option[data-product-id="10516921352530"]');
    if (addonOption) {
      const checkbox = addonOption.querySelector('.modal-addon-product__switch-input');
      if (checkbox) {
        updateGelflexBadge(checkbox);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkInitialState);
  } else {
    // Use setTimeout to ensure custom elements are initialized
    setTimeout(checkInitialState, 100);
  }

  // Also listen for addon-toggle events as fallback
  document.addEventListener('addon-toggle', (e) => {
    const productId = String(e.detail?.productId);
    if (productId === '10516921352530') {
      const addonOption = document.querySelector('.modal-addon-product__option[data-product-id="10516921352530"]');
      const checkbox = addonOption?.querySelector('.modal-addon-product__switch-input');
      if (checkbox) {
        updateGelflexBadge(checkbox);
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_modal-main-container"] && !Shopify.designMode) return;
  try {
    function applyModalBackground() {
    const mainContainers = document.querySelectorAll('.modal-main-container[data-modal-bg-color]');
    mainContainers.forEach(container => {
      const bgColor = container.dataset.modalBgColor;
      if (bgColor) {
        const dialog = container.closest('dialog');
        // Apply to regular modal wrapper
        const wrapper = dialog?.querySelector('.modal-wrapper');
        if (wrapper) {
          wrapper.style.backgroundColor = bgColor;
        }
        // Apply to sub-modal wrapper
        const subModalWrapper = dialog?.querySelector('.sub-modal-wrapper');
        if (subModalWrapper) {
          subModalWrapper.style.backgroundColor = bgColor;
        }
      }
    });
  }

  // Apply on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyModalBackground);
  } else {
    applyModalBackground();
  }

  // Apply when modals open
  document.addEventListener('DOMContentLoaded', () => {
    const dialogs = document.querySelectorAll('dialog');
    dialogs.forEach(dialog => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            if (dialog.hasAttribute('open')) {
              applyModalBackground();
            }
          }
        });
      });
      observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_modal-selected-product"] && !Shopify.designMode) return;
  try {
    class ModalSelectedProduct extends HTMLElement {
    connectedCallback() {
      console.log('[ModalSelectedProduct] ===== INITIALIZING =====');
      
      this.badges = this.querySelector('[data-ref="badges"]');
      this.badgesWrapper = this.badges?.querySelector('.modal-selected-product__badges-wrapper');
      this.priceElement = this.querySelector('[data-ref="price"]');
      this.gelflexBadge = this.querySelector('[data-ref="gelflexBadge"]');
      this.infoButton = this.querySelector('[data-ref="infoButton"]');
      this.firstVariantBadge = this.querySelector('.modal-selected-product__badge');
      
      // Get text settings from data attributes
      this.withGelflexText = this.dataset.withGelflexText || 'With Gelflex';
      this.noGelflexText = this.dataset.noGelflexText || 'No Gelflex';
      
      // Track addon state and current price
      this.addonEnabled = false;
      this.currentPrice = 0;
      this.lastCheckedVariants = {}; // Track what we last saw
      
      // Setup info button
      if (this.infoButton) {
        this.infoButton.addEventListener('click', () => this.handleInfoClick());
      }
      
      // Start polling for changes every 200ms - simple and reliable
      this.pollInterval = setInterval(() => this.checkForChanges(), 200);
      
      // Initial state check
      this.checkForChanges();
      
      console.log('[ModalSelectedProduct] ===== INITIALIZED =====');
    }

    /**
     * Check for any changes in the DOM (variants or addon)
     * This runs every 200ms - simple and bulletproof
     */
    checkForChanges() {
      // Check addon state
      const addonCheckbox = this.closest('product-configurator-component')?.querySelector('.modal-addon-product__switch-input');
      if (addonCheckbox) {
        const wasEnabled = this.addonEnabled;
        this.addonEnabled = addonCheckbox.checked;
        
        if (wasEnabled !== this.addonEnabled) {
          console.log('[ModalSelectedProduct] Addon changed:', this.addonEnabled);
          this.updateInfoButtonState();
          if (this.gelflexBadge) {
            const text = this.addonEnabled ? this.withGelflexText : this.noGelflexText;
            this.gelflexBadge.textContent = text;
            if (this.addonEnabled) {
              this.gelflexBadge.classList.remove('modal-selected-product__variant-badge--secondary');
            } else {
              this.gelflexBadge.classList.add('modal-selected-product__variant-badge--secondary');
            }
          }
          // Enable/disable addon inputs in cart form
          this.updateAddonInputsInCartForm(this.addonEnabled);
          // Update price when addon changes
          this.updateTotalPrice();
        }
      }
      
      // Check variant selections
      const configurator = this.closest('product-configurator-component');
      const variantSelectors = configurator?.querySelectorAll('modal-variant-selector');
      
      if (variantSelectors) {
        let changed = false;
        
        variantSelectors.forEach((selector) => {
          const selectedInput = selector.querySelector('input[type="radio"]:checked');
          
          if (selectedInput) {
            const optionPosition = parseInt(selectedInput.dataset.optionPosition);
            const optionValue = selectedInput.value;
            const optionName = selectedInput.dataset.optionName;
            const variantPrice = parseInt(selectedInput.dataset.variantPrice) || 0;
            
            // Check if this changed
            if (this.lastCheckedVariants[optionPosition] !== optionValue) {
              console.log(`[ModalSelectedProduct] Variant ${optionPosition} changed:`, optionValue);
              changed = true;
              this.lastCheckedVariants[optionPosition] = optionValue;
              
              // Update top badge for position 1
              if (optionPosition == 1 && this.firstVariantBadge) {
                this.firstVariantBadge.textContent = optionValue;
              }
              
              // Update badge in wrapper
              this.updateVariantBadge(optionName, optionValue, optionPosition);
            }
          }
        });
        
        // If anything changed, update price and cart form
        if (changed || this.currentPrice === 0) {
          this.updateTotalPrice();
          this.updateCartFormVariantId();
        }
      }
    }

    disconnectedCallback() {
      if (this.pollInterval) {
        clearInterval(this.pollInterval);
      }
    }

    /**
     * Enable or disable addon inputs in the cart form
     * @param {boolean} enabled - Whether addon is enabled
     */
    updateAddonInputsInCartForm(enabled) {
      const form = document.getElementById('configurator-cart-form');
      if (!form) {
        console.warn('[ModalSelectedProduct] Cart form not found');
        return;
      }
      
      const addonVariantInput = form.querySelector('[data-ref="addonVariantInput"]');
      const addonQuantityInput = form.querySelector('[data-ref="addonQuantityInput"]');
      
      if (addonVariantInput) {
        addonVariantInput.disabled = !enabled;
      }
      if (addonQuantityInput) {
        addonQuantityInput.disabled = !enabled;
      }
      
      console.log('[ModalSelectedProduct] Addon form inputs', enabled ? 'enabled' : 'disabled');
    }

    /**
     * Update the cart form with the correct variant ID
     */
    updateCartFormVariantId() {
      const variantId = this.findCombinedVariantId();
      if (!variantId) {
        console.warn('[ModalSelectedProduct] No variant ID found to update cart form');
        return;
      }
      
      const form = document.getElementById('configurator-cart-form');
      const mainVariantInput = form?.querySelector('[data-ref="mainVariantInput"]');
      
      if (mainVariantInput) {
        mainVariantInput.value = variantId;
        console.log('[ModalSelectedProduct] Updated cart form variant ID:', variantId);
      } else {
        console.warn('[ModalSelectedProduct] Cart form main variant input not found');
      }
    }

    /**
     * Find the variant ID that matches all selected options
     * @returns {string|null} - The variant ID
     */
    findCombinedVariantId() {
      const variantSelectors = this.closest('product-configurator-component')?.querySelectorAll('modal-variant-selector');
      
      if (!variantSelectors || variantSelectors.length === 0) {
        return null;
      }
      
      // Collect all selected variant IDs
      const selectedVariantIds = [];
      variantSelectors.forEach(selector => {
        const selectedInput = selector.querySelector('input[type="radio"]:checked');
        if (selectedInput && selectedInput.dataset.variantId) {
          selectedVariantIds.push(selectedInput.dataset.variantId);
        }
      });
      
      if (selectedVariantIds.length === 0) {
        return null;
      }
      
      // If we have multiple options, find the variant ID that appears for all selections
      if (selectedVariantIds.length > 1) {
        // Count occurrences
        const variantIdCounts = {};
        selectedVariantIds.forEach(id => {
          variantIdCounts[id] = (variantIdCounts[id] || 0) + 1;
        });
        
        // Find variant that appears for all options (shared variant)
        const sharedVariantId = Object.keys(variantIdCounts).find(id => 
          variantIdCounts[id] === selectedVariantIds.length
        );
        
        if (sharedVariantId) {
          return sharedVariantId;
        }
      }
      
      // Fallback: return the first variant ID
      return selectedVariantIds[0];
    }

    /**
     * Calculate and update total price including addon
     */
    updateTotalPrice() {
      // Find the actual combined variant price
      let totalPrice = this.findCombinedVariantPrice();
      
      console.log('[ModalSelectedProduct] Base price before addon:', totalPrice);
      
      // Add addon price if enabled
      if (this.addonEnabled) {
        const addonBlock = this.closest('product-configurator-component')?.querySelector('.modal-addon-product');
        if (addonBlock) {
          const addonPriceText = addonBlock.querySelector('.modal-addon-product__badge--price')?.textContent;
          console.log('[ModalSelectedProduct] Addon price text:', addonPriceText);
          if (addonPriceText) {
            // Extract price from text like "+£16.00"
            const addonPriceMatch = addonPriceText.match(/[\d.]+/);
            if (addonPriceMatch) {
              const addonPrice = parseFloat(addonPriceMatch[0]) * 100; // Convert to cents
              console.log('[ModalSelectedProduct] Adding addon price:', addonPrice);
              totalPrice += addonPrice;
            }
          }
        } else {
          console.warn('[ModalSelectedProduct] Addon block not found');
        }
      }
      
      this.currentPrice = totalPrice;
      
      console.log('[ModalSelectedProduct] Final total price:', totalPrice, { addonEnabled: this.addonEnabled });
      
      // Update price display
      this.updatePrice(totalPrice);
      
      // Update checkout button price
      this.updateCheckoutButtonPrice(totalPrice);
    }

    /**
     * Find the combined variant price that matches all selected options
     * @returns {number} - The price in cents
     */
    findCombinedVariantPrice() {
      const variantSelectors = this.closest('product-configurator-component')?.querySelectorAll('modal-variant-selector');
      
      if (!variantSelectors || variantSelectors.length === 0) {
        const productPriceMin = parseInt(this.dataset.productPriceMin) || 0;
        return productPriceMin;
      }
      
      // Collect all selected option values and variant IDs
      const selectedOptions = {};
      const selectedVariantIds = [];
      
      variantSelectors.forEach(selector => {
        const selectedInput = selector.querySelector('input[type="radio"]:checked');
        if (selectedInput) {
          const optionPosition = parseInt(selectedInput.dataset.optionPosition);
          const optionValue = selectedInput.value;
          const variantId = selectedInput.dataset.variantId;
          const variantPrice = parseInt(selectedInput.dataset.variantPrice) || 0;
          
          selectedOptions[optionPosition] = {
            value: optionValue,
            variantId: variantId,
            price: variantPrice
          };
          
          if (variantId) {
            selectedVariantIds.push(variantId);
          }
        }
      });
      
      console.log('[ModalSelectedProduct] Selected options for price lookup:', selectedOptions);
      
      // If we have multiple options, try to find a shared variant ID
      // (This would be the case if one variant has multiple option combinations)
      if (selectedVariantIds.length > 1) {
        // Check if any variant ID appears multiple times (meaning it combines multiple options)
        const variantIdCounts = {};
        selectedVariantIds.forEach(id => {
          variantIdCounts[id] = (variantIdCounts[id] || 0) + 1;
        });
        
        // If a variant ID appears for all options, that's our combined variant
        const combinedVariantId = Object.keys(variantIdCounts).find(id => 
          variantIdCounts[id] === selectedVariantIds.length
        );
        
        if (combinedVariantId) {
          // Get the price from any option with this variant ID
          const matchingOption = Object.values(selectedOptions).find(opt => opt.variantId === combinedVariantId);
          if (matchingOption) {
            console.log('[ModalSelectedProduct] Found shared variant:', combinedVariantId, 'price:', matchingOption.price);
            return matchingOption.price;
          }
        }
      }
      
      // If no shared variant, calculate by adding premiums to base price
      // Each option's price includes the base, so we subtract base from each and add them together
      const productPriceMin = parseInt(this.dataset.productPriceMin) || 0;
      let totalPrice = productPriceMin; // Start with base price
      
      Object.values(selectedOptions).forEach(opt => {
        if (opt.price > productPriceMin) {
          const premium = opt.price - productPriceMin;
          totalPrice += premium;
          console.log('[ModalSelectedProduct] Adding premium:', premium, 'for option:', opt.value);
        }
      });
      
      console.log('[ModalSelectedProduct] Calculated total price:', totalPrice, '(base:', productPriceMin, ')');
      return totalPrice;
    }

    /**
     * Update checkout button price
     */
    updateCheckoutButtonPrice(price) {
      const checkoutButton = this.closest('dialog-component')?.querySelector('modal-smart-checkout-button');
      if (checkoutButton && checkoutButton.updatePrice) {
        const formattedPrice = this.formatPrice(price);
        checkoutButton.updatePrice(formattedPrice);
        console.log('[ModalSelectedProduct] Updated checkout button price:', formattedPrice);
      }
    }


    /**
     * Handle info button click - opens appropriate modal based on addon state
     */
    handleInfoClick() {
      if (!this.infoButton) return;
      
      const urlWithAddon = this.infoButton.dataset.urlWithAddon;
      const urlWithoutAddon = this.infoButton.dataset.urlWithoutAddon;
      
      // Use current addon state (kept up to date by polling)
      const modalId = this.addonEnabled ? urlWithAddon : urlWithoutAddon;
      
      console.log('[ModalSelectedProduct] Opening modal:', {
        addonEnabled: this.addonEnabled,
        selectedModalId: modalId,
        currentPrice: this.currentPrice
      });
      
      if (modalId && modalId !== '') {
        const cleanModalId = modalId.replace('#', '');
        const parentModal = this.closest('dialog-component.header-menu-modal');
        if (parentModal && window.openSubModal) {
          window.openSubModal(cleanModalId);
          // Update sub-modal prices after it opens
          setTimeout(() => this.updateSubModalPrices(cleanModalId), 100);
        } else if (window.openModalWithTransition) {
          window.openModalWithTransition(cleanModalId);
          // Update modal prices after it opens
          setTimeout(() => this.updateSubModalPrices(cleanModalId), 100);
        }
      }
    }

    /**
     * Update prices in the opened sub-modal
     * @param {string} modalId - The ID of the sub-modal
     */
    updateSubModalPrices(modalId) {
      const subModal = document.getElementById(modalId);
      if (!subModal) {
        console.warn('[ModalSelectedProduct] Sub-modal not found:', modalId);
        return;
      }
      
      const formattedPrice = this.formatPrice(this.currentPrice);
      
      // Update all price elements (including placeholders and static prices)
      const priceElements = subModal.querySelectorAll('.modal-image-badge__price-text');
      priceElements.forEach(el => {
        el.textContent = formattedPrice;
        console.log('[ModalSelectedProduct] Updated price to:', formattedPrice);
      });
      
      // Update checkout button in sub-modal footer
      const checkoutButton = subModal.querySelector('modal-smart-checkout-button');
      if (checkoutButton && checkoutButton.updatePrice) {
        checkoutButton.updatePrice(formattedPrice);
        console.log('[ModalSelectedProduct] Updated sub-modal checkout button:', formattedPrice);
      }
      
      // Update any other price displays in footer
      const footerPrices = subModal.querySelectorAll('.modal-footer-menu__price, [data-price-display]');
      footerPrices.forEach(el => {
        el.textContent = formattedPrice;
      });
      
      // Update the comfort label with the selected first variant option
      const firstVariantOption = this.lastCheckedVariants[1]; // Position 1 is first variant selector
      if (firstVariantOption) {
        const comfortLabels = subModal.querySelectorAll('.modal-richtext__title-wrapper .comfort__label');
        comfortLabels.forEach(label => {
          label.textContent = firstVariantOption;
          console.log('[ModalSelectedProduct] Updated comfort label to:', firstVariantOption);
        });
      }
      
      console.log('[ModalSelectedProduct] Sub-modal prices and labels updated');
    }

    /**
     * Update info button state to reflect current addon selection
     */
    updateInfoButtonState() {
      if (!this.infoButton) return;
      
      // Toggle 'active' class based on addon state
      if (this.addonEnabled) {
        this.infoButton.classList.add('active');
      } else {
        this.infoButton.classList.remove('active');
      }
    }

    /**
     * Format variant badge text to show only relevant part
     * @param {string} optionValue - The full option value
     * @param {string} optionName - The option name (e.g., "Size", "Thickness")
     * @returns {string} - Formatted badge text
     */
    formatVariantBadgeText(optionValue, optionName) {
      if (!optionValue) return '';
      
      // If value contains parentheses, extract content inside
      const parenthesesMatch = optionValue.match(/\(([^)]+)\)/);
      if (parenthesesMatch) {
        return parenthesesMatch[1].trim();
      }
      
      // If value contains em dash, extract text before it
      const emDashIndex = optionValue.indexOf(' — ');
      if (emDashIndex !== -1) {
        const beforeDash = optionValue.substring(0, emDashIndex).trim();
        // For thickness options, append "thickness"
        if (optionName && optionName.toLowerCase().includes('thickness')) {
          return `${beforeDash} thickness`;
        }
        return beforeDash;
      }
      
      // Return original value if no special formatting needed
      return optionValue;
    }

    /**
     * Update a variant option badge
     * @param {string} optionName - The option name (e.g., "Size")
     * @param {string} optionValue - The option value (e.g., "Single")
     * @param {number} optionPosition - The option position (1, 2, etc.)
     */
    updateVariantBadge(optionName, optionValue, optionPosition) {
      if (!this.badgesWrapper) return;
      
      const formattedText = this.formatVariantBadgeText(optionValue, optionName);
      
      let badge = this.badgesWrapper.querySelector(`[data-option-position="${optionPosition}"]`);
      
      if (badge) {
        badge.textContent = formattedText;
        badge.dataset.optionName = optionName;
        console.log(`[ModalSelectedProduct] Updated badge ${optionPosition}:`, formattedText);
      } else {
        // Create new badge
        badge = document.createElement('span');
        badge.className = 'modal-selected-product__variant-badge';
        badge.dataset.optionPosition = optionPosition;
        badge.dataset.optionName = optionName;
        badge.textContent = formattedText;
        
        const insertPosition = this.findBadgeInsertPosition(optionPosition);
        if (insertPosition) {
          this.badgesWrapper.insertBefore(badge, insertPosition);
        } else {
          this.badgesWrapper.appendChild(badge);
        }
        
        console.log(`[ModalSelectedProduct] Created badge ${optionPosition}:`, formattedText);
      }
    }

    /**
     * Find the correct position to insert a badge based on option position
     * @param {number} optionPosition - The option position for the new badge
     * @returns {HTMLElement|null} - The element to insert before, or null to append
     */
    findBadgeInsertPosition(optionPosition) {
      // Get all existing badges
      const existingBadges = Array.from(this.badgesWrapper.querySelectorAll('[data-option-position]'));
      
      // Find the first badge with a higher position number
      for (const existingBadge of existingBadges) {
        const existingPosition = parseInt(existingBadge.dataset.optionPosition);
        if (existingPosition > optionPosition) {
          return existingBadge;
        }
      }
      
      // If gelflex badge exists, insert before it
      if (this.gelflexBadge && this.badgesWrapper.contains(this.gelflexBadge)) {
        return this.gelflexBadge;
      }
      
      // Otherwise append to end
      return null;
    }

    /**
     * Update the displayed price
     * @param {number} price - The price in cents
     */
    updatePrice(price) {
      if (!this.priceElement) {
        console.warn('[ModalSelectedProduct] priceElement not found');
        return;
      }
      
      // Format price without cents
      const formattedPrice = this.formatPrice(price);
      this.priceElement.textContent = formattedPrice;
      
      console.log('[ModalSelectedProduct] Updated price display:', formattedPrice);
    }

    /**
     * Format price without cents
     * @param {number} price - The price in cents
     * @returns {string} - Formatted price like £88
     */
    formatPrice(price) {
      const priceInPounds = Math.round(price / 100);
      return `£${priceInPounds}`;
    }

  }

  if (!customElements.get('modal-selected-product')) {
    customElements.define('modal-selected-product', ModalSelectedProduct);
  }

  /**
   * CHECKOUT FLOW:
   * 1. User clicks checkout button (main modal or sub-modal footer)
   * 2. modal-smart-checkout-button fires 'checkout-submit' event
   * 3. This global handler catches the event
   * 4. Forwards event to product-configurator-component
   * 5. Configurator gathers current state:
   *    - Selected variant ID (Size + Thickness combination)
   *    - Addon enabled state
   * 6. Builds items array: [main variant, addon (if enabled)]
   * 7. Sends to Shopify: POST /cart/add.js
   * 8. On success: Redirects to /cart
   * 9. On error: Shows error message
   */
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_modal-smart-checkout-button"] && !Shopify.designMode) return;
  try {
    class ModalSmartCheckoutButton extends HTMLElement {
    #disabledValues = []; 
    #floatingButton = null;
    #footerButton = null;
    #floatingCheckoutButton = null;
    #footerCheckoutButton = null;
    #scrollThreshold = 100;
    #footerElement = null;
    #isScrolling = false;
    #scrollContainer = null;

    connectedCallback() {

      this.#disabledValues = (this.dataset.disabledValue || '')
      .split(',')
      .map(v => v.trim())
      .filter(Boolean);


      this.#floatingButton = this.querySelector('[data-floating-button]');
      this.#footerButton = this.querySelector('[data-footer-button]');
      this.#floatingCheckoutButton = this.querySelector('[data-ref="floatingCheckoutButton"]');
      this.#footerCheckoutButton = this.querySelector('[data-ref="footerCheckoutButton"]');

      // Add click handlers
      if (this.#floatingCheckoutButton) {
        this.#floatingCheckoutButton.addEventListener('click', () => this.handleCheckoutClick());
      }
      if (this.#footerCheckoutButton) {
        this.#footerCheckoutButton.addEventListener('click', () => this.handleCheckoutClick());
      }

      // Find scroll container (dialog or window)
      const modal = this.closest('dialog-component');
      const dialog = modal?.querySelector('dialog');
      this.#scrollContainer = dialog || window;

      if (this.#floatingButton && this.#footerButton) {
        this.setupScrollListener();
        this.checkInitialState();
      }
    }

    disconnectedCallback() {
      if (this.#scrollContainer === window) {
        window.removeEventListener('scroll', this.handleScroll);
      } else {
        this.#scrollContainer?.removeEventListener('scroll', this.handleScroll);
      }
    }

    setupScrollListener() {
      this.handleScroll = this.handleScroll.bind(this);
      
      if (this.#scrollContainer === window) {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
      } else {
        this.#scrollContainer?.addEventListener('scroll', this.handleScroll, { passive: true });
      }
      
      this.handleScroll();
    }

    checkInitialState() {
      const modal = this.closest('dialog-component');
      if (modal) {
        const observer = new MutationObserver(() => {
          setTimeout(() => this.handleScroll(), 100);
        });
        observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
      }
    }

    handleScroll() {
      if (this.#isScrolling) return;
      this.#isScrolling = true;
      requestAnimationFrame(() => {
        this.updateButtonState();
        this.#isScrolling = false;
      });
    }

    updateButtonState() {
      let scrollY, scrollHeight, clientHeight;
      
      if (this.#scrollContainer === window) {
        scrollY = window.scrollY || window.pageYOffset;
        scrollHeight = document.documentElement.scrollHeight;
        clientHeight = window.innerHeight;
      } else {
        scrollY = this.#scrollContainer.scrollTop;
        scrollHeight = this.#scrollContainer.scrollHeight;
        clientHeight = this.#scrollContainer.clientHeight;
      }

      const scrollBottom = scrollHeight - scrollY - clientHeight;
      
      // Get footer button position relative to viewport
      const footerRect = this.#footerButton?.getBoundingClientRect();
      const footerInView = footerRect && footerRect.top < clientHeight;

      const isAtTop = scrollY < this.#scrollThreshold;
      const isNearFooter = scrollBottom < 200;

      // Show floating button when scrolled down but not at top or near footer
      if (isAtTop) {
        // Hide at top
        this.#floatingButton.setAttribute('data-visible', 'false');
      } else if (isNearFooter || footerInView) {
        // Hide when footer is visible (merged state)
        this.#floatingButton.setAttribute('data-visible', 'false');
      } else {
        // Show while scrolling in middle
        this.#floatingButton.setAttribute('data-visible', 'true');
      }
    }

    /**
     * Handle checkout button click
     * Dispatches event for configurator to handle
     */
    async handleCheckoutClick() {
      const selectedRadio = document.querySelector(
        '.modal-variant-selector__radio input[type="radio"][data-option-name="Thickness"]:checked'
      );
    
      if (this.#disabledValues.includes(selectedRadio?.value)) {
        return;
      }


      console.log('[Checkout Button] Looking for form...');
      
      // Try multiple selectors
      const formById = document.getElementById('configurator-cart-form');
      const formByType = document.querySelector('form[data-type="add-to-cart-form"]');
      const formInConfigurator = document.querySelector('product-configurator-component form');
      
      const form = formById || formByType || formInConfigurator;
      
      if (!form) {
        console.error('[Checkout Button] Cart form not found anywhere!');
        return;
      }
      
      console.log('[Checkout Button] Found form, clearing cart first...');
      
      try {
        // First, clear the cart
        await fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          }
        });
        
        console.log('[Checkout Button] Cart cleared, now submitting form...');
        
        // Then submit the form to add new items and redirect to checkout
        form.submit();
      } catch (error) {
        console.error('[Checkout Button] Error clearing cart:', error);
        // Even if clearing fails, still try to submit the form
        form.submit();
      }
    }

    /**
     * Update the displayed price
     * @param {string} formattedPrice - The formatted price string (e.g., "£88")
     */
    updatePrice(formattedPrice) {
      const priceElements = this.querySelectorAll('[data-price]');
      priceElements.forEach(el => {
        el.textContent = formattedPrice;
      });
    }

    /**
     * Set button loading state
     * @param {boolean} loading - Whether buttons should be in loading state
     */
    setLoading(loading) {
      const buttons = [this.#floatingCheckoutButton, this.#footerCheckoutButton];
      buttons.forEach(button => {
        if (button) {
          button.disabled = loading;
          if (loading) {
            button.style.opacity = '0.6';
            button.style.cursor = 'wait';
          } else {
            button.style.opacity = '';
            button.style.cursor = '';
          }
        }
      });
    }
  }

  if (!customElements.get('modal-smart-checkout-button')) {
    customElements.define('modal-smart-checkout-button', ModalSmartCheckoutButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_modal-variant-selector"] && !Shopify.designMode) return;
  try {
    class ModalVariantSelector extends HTMLElement {
    connectedCallback() {
      const options = this.querySelectorAll('.modal-variant-selector__option input[type="radio"]');
      
      // Ensure first option is checked if none are checked
      const checkedOption = this.querySelector('input[type="radio"]:checked');
      if (!checkedOption && options.length > 0) {
        options[0].checked = true;
        const firstOption = options[0].closest('.modal-variant-selector__option');
        if (firstOption) {
          firstOption.classList.add('modal-variant-selector__option--selected');
        }
      }
      
      options.forEach(option => {
        option.addEventListener('change', (e) => {
          this.handleVariantChange(e.target);
        });
      });
    }

    handleVariantChange(selectedInput) {
      const option = selectedInput.closest('.modal-variant-selector__option');
      const allOptions = this.querySelectorAll('.modal-variant-selector__option');
      const basePrice = this.getBasePrice();
      
      allOptions.forEach(opt => {
        opt.classList.remove('modal-variant-selector__option--selected');
        const selectedBadge = opt.querySelector('.modal-variant-selector__badge--selected');
        if (selectedBadge) selectedBadge.remove();
      });
      
      option.classList.add('modal-variant-selector__option--selected');
      const selectedPriceBadge = option.querySelector('.modal-variant-selector__badge--price');
      if (selectedPriceBadge) selectedPriceBadge.remove();
      
      allOptions.forEach(opt => {
        this.updatePriceBadge(opt, basePrice);
      });
      
      // Add selected badge
      const badges = option.querySelector('.modal-variant-selector__option-badges');
      if (badges && !badges.querySelector('.modal-variant-selector__badge--selected')) {
        const selectedBadge = document.createElement('span');
        selectedBadge.className = 'modal-variant-selector__badge modal-variant-selector__badge--selected';
        selectedBadge.textContent = 'Selected';
        badges.prepend(selectedBadge);
      }
      
      const variantId = selectedInput.dataset.variantId;
      const variantPrice = selectedInput.dataset.variantPrice;
      const optionName = selectedInput.dataset.optionName;
      const optionValue = selectedInput.dataset.optionValue;
      const productId = this.dataset.productId;
      
      if (variantId) {
        this.dispatchEvent(new CustomEvent('variant-selected', {
          detail: { 
            variantId,
            variantPrice: parseInt(variantPrice) || 0,
            optionName,
            optionValue,
            productId,
            optionPosition: selectedInput.dataset.optionPosition
          },
          bubbles: true
        }));
      }
    }

    getBasePrice() {
      const productPriceMin = this.dataset.productPriceMin;
      if (productPriceMin) {
        return parseInt(productPriceMin) || 0;
      }
      return 0;
    }

    updatePriceBadge(option, basePrice) {
      const input = option.querySelector('input[type="radio"]');
      if (!input) return;
      
      const variantPrice = parseInt(input.dataset.variantPrice) || 0;
      if (variantPrice === 0) return; // Skip if variant price is not set
      
      const priceDiff = variantPrice - basePrice;
      const badges = option.querySelector('.modal-variant-selector__option-badges');
      
      if (!badges) return;
      
      // Remove existing price badge
      const existingPriceBadge = badges.querySelector('.modal-variant-selector__badge--price');
      if (existingPriceBadge) existingPriceBadge.remove();
      
      if (!option.classList.contains('modal-variant-selector__option--selected') && priceDiff !== 0) {
        const priceBadge = document.createElement('span');
        priceBadge.className = 'modal-variant-selector__badge modal-variant-selector__badge--price';
        const sign = priceDiff > 0 ? '+' : '-';
        priceBadge.textContent = `${sign}${this.formatPrice(Math.abs(priceDiff))}`;
        badges.appendChild(priceBadge);
      }
    }

    formatPrice(priceInCents) {
      const formatter = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return formatter.format(priceInCents / 100);
    }
  }

  if (!customElements.get('modal-variant-selector')) {
    customElements.define('modal-variant-selector', ModalVariantSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_what-topper-slider"] && !Shopify.designMode) return;
  try {
    (function() {
    const slider = document.querySelector('.what-topper__slider');
    if (!slider) return;

    function moveSlides() {
      const shopifyBlocks = slider.querySelectorAll('.shopify-block');
      shopifyBlocks.forEach(block => {
        const slide = block.querySelector('swiper-slide');
        if (slide) {
          slider.appendChild(slide);
          block.remove();
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', moveSlides);
    } else {
      moveSlides();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
